<template>
    <b-container class="my-5 p-4 border rounded shadow bg-white" ref="invoice">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <h2>Invoice</h2>
        <b-button variant="primary" @click="printInvoice" class="no-print">
            <b-icon icon="printer-fill" class="mr-2"></b-icon>
            Print
        </b-button>

      </div>
  
      <!-- Company and Invoice Info -->
      <b-row class="mb-4">
        <b-col>
          <h5>Payton</h5>
          <p>123 Business Street<br>City, Country</p>
        </b-col>
        <b-col class="text-right">
          <p><strong>Invoice #: </strong>INV-001</p>
          <p><strong>Date: </strong>{{ invoiceDate }}</p>
        </b-col>
      </b-row>
  
      <!-- Items -->
      <b-table :items="items" :fields="fields" small striped bordered class="mb-4" responsive>
        <template #cell(total)="data">
          ${{ (data.item.quantity * data.item.price).toFixed(2) }}
        </template>
      </b-table>
  
      <b-row class="justify-content-end mb-4">
        <b-col cols="4">
          <h5>Total: ${{ total.toFixed(2) }}</h5>
        </b-col>
      </b-row>
  
      <!-- Bank Info -->
      <b-card header="Bank Information" header-tag="header" class="border-info">
        <p><strong>Bank Name:</strong> {{ bank.bankName }}</p>
        <p><strong>IBAN:</strong> {{ bank.iban }}</p>
        <p class="text-muted">{{ bank.description }}</p>
      </b-card>
    </b-container>
  </template>
  
  <script>
  export default {
    name: 'InvoiceComponent',
    props: {
        items: {
        type: Array,
        required: true,
        },
    },
    data() {
      return {
        invoiceDate: new Date().toLocaleDateString(),
       
        fields: [
          { key: 'name', label: 'Item' },
          { key: 'quantity', label: 'Quantity' },
          { key: 'price', label: 'Price', formatter: (val) => `$${val.toFixed(2)}` },
          { key: 'total', label: 'Total' },
        ],
        bank: {
          bankName: 'Kazakhstan National Bank',
          iban: 'KZ860701234567890123',
          description: 'Please make the payment within 7 working days using the IBAN above.',
        },
      };
    },
    computed: {
      total() {
        return this.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
      },
    },
    methods: {
        printInvoice() {
            const printContents = this.$refs.invoice.innerHTML;
            const printWindow = window.open('', '', 'width=800,height=600');
            printWindow.document.write(`
                <html>
                <head>
                    <title>Invoice</title>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css">
                    <style>
                    body { padding: 20px; }
                    .no-print { display: none !important; }
                    .border, .table { border-color: #dee2e6 !important; }
                    </style>
                </head>
                <body onload="window.print(); window.close();">
                    ${printContents}
                </body>
                </html>
            `);
            printWindow.document.close();
        }
    },
  };
  </script>
  
  <style scoped>
  @media print {
    button,
    .b-button,
    .btn,
    .d-flex {
      display: none !important;
    }
  
    body {
      margin: 0;
    }
  
    .container {
      box-shadow: none;
      border: none;
    }
  }
  </style>
  